import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/zond80/Documents/WORK_SITES/appdb.cc/publisher/appdb-publisher/apps/id/layouts/default.vue")),
  centered: defineAsyncComponent(() => import("/Users/zond80/Documents/WORK_SITES/appdb.cc/publisher/appdb-publisher/packages/core/layouts/centered.vue")),
  "no-menu": defineAsyncComponent(() => import("/Users/zond80/Documents/WORK_SITES/appdb.cc/publisher/appdb-publisher/packages/core/layouts/no-menu.vue"))
}